import { TableColumnTypes } from 'src/Components/DataGrid';

/** Режим отображения колонки, приходящий с бэкенда (настраивается в конфиге) */
export type DisplaySize = 'full' | 'compact' | null;

/** Ширина экрана, при которой и ниже включается компактная раскладка колонок */
export const COMPACT_LAYOUT_BREAKPOINT = 1440;

/**
 * Размеры колонок по категориям для обычного и экран ноутбука (≤ 1440)
 * `width`- предпочтительная ширина(`undefined` = тянущаяся), `minWidth`- минимум
 */
const COLUMN_DIMENSIONS = {
	regular: {
		date: { width: 192, minWidth: 150 },
		compact: { width: 164, minWidth: 150 },
		flexible: { width: undefined, minWidth: 220 },
	},
	small: {
		date: { width: 150, minWidth: 120 },
		compact: { width: 140, minWidth: 120 },
		flexible: { width: undefined, minWidth: 180 },
	},
} as const;

/** Ширина служебной ячейки: пустая ячейка шапки, тулбар строки, кнопка разворота */
export const SERVICE_CELL_WIDTH = 32;
/** Ширина левой служебной колонки в режиме мультивыбора (чекбокс + разворот) */
export const CHECKBOX_COLUMN_WIDTH = 60;
/** Отступ между скроллбаром и краем контейнера таблицы */
export const SCROLLBAR_GUTTER = 6;
/** Толщина кастомного скроллбара таблицы */
export const SCROLLBAR_SIZE = 8;
/** Отступ между скроллбаром и таблицей */
export const TABLE_SCROLL_GAP = 10;

/** Результат вычисления размеров колонки */
export type ColumnSizing = {
	/** Ширина колонки по умолчанию, если `undefined`- колонка тянущаяся и делит доступную ширину строки */
	width?: number;
	/** Минимальный размер колонки, до которого её можно сжать */
	minWidth: number;
};

/** Типы колонок, содержимое которых считается датой */
const isDateType = (type?: TableColumnTypes): boolean => {
	return type === 'date' || type === 'dateTime';
};

/**
 * Вычисляет размеры колонки. Источник узости/ширины- тип и режим `displaySize`,
 * а конкретные значения зависят от экрана (обычный/компактный ≤ 1440):
 *  - тип date -> фиксированная ширина (192/150px, min 150/120px)
 *  - displaySize = 'compact' -> узкая колонка (164/140px, min 150/120px)
 *  - всё остальное -> тянущаяся (min 220/180px)
 */
export const getColumnSizing = (
	type?: TableColumnTypes,
	displaySize?: DisplaySize,
	isSmallScreen = false,
): ColumnSizing => {
	const dims = isSmallScreen
		? COLUMN_DIMENSIONS.small
		: COLUMN_DIMENSIONS.regular;
	// 1. Дата определяется по типу колонки
	if (isDateType(type)) {
		return { ...dims.date };
	}
	// 2. Компактный режим- узкая колонка
	if (displaySize === 'compact') {
		return { ...dims.compact };
	}
	// 3. Всё остальное тянется
	return { ...dims.flexible };
};
